import produce from 'immer';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as Sentry from "@sentry/react";

import type { User } from '~/types/models';

export interface IAuthSlice {
  loaded: boolean;
  loading: boolean;
  user: User | null;
}

let widget: {
    removeFromDom: () => void;
  } | null = null;

const initialState: IAuthSlice = {
  loaded: false,
  loading: false,
  user: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    addDocumentationPageSeen: (_state, _payload: PayloadAction<string>) => {},
    addDocumentationPageSeenToUserMeta: (state, { payload }: PayloadAction<string>) => {
      return produce(state, (draft) => {
        if (!draft.user) {
          return;
        }
        if (!draft.user.meta) {
          draft.user.meta = {};
        }
        if (!Array.isArray(draft.user.meta.documentationPagesSeen)) {
          draft.user.meta.documentationPagesSeen = [];
        }
        draft.user.meta.documentationPagesSeen.push(payload);
      });
    },
    fetchUser: (_state) => {},
    hideSentryWidget(_state) {
      widget?.removeFromDom();
    },
    login: (_state) => {},
    logout: (_state) => {},
    setLoaded(state, { payload }: PayloadAction<boolean>) {
      state.loaded = payload;
    },
    setLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setUser(state, { payload }: PayloadAction<User | null>) {
      state.user = payload;
    },
    showSentryWidget(_state) {
      widget = Sentry.getFeedback()?.createWidget() ?? null;
    },
  },
});

const { actions, reducer: authReducer } = authSlice;

const reducer = persistReducer(
  {
    key: 'CSN_Pointage:Auth',
    storage,
    whitelist: ['user'],
  },
  authReducer,
);

export { actions, reducer };
